import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PatientKioskQuestionnaires from '../../containers/Questionnaires/PatientKioskQuestionnaires';

class PatientKioskQuestionnairesPage extends React.Component {
  render() {
    return (
      <PatientKioskQuestionnaires />
    );
  }
}
PatientKioskQuestionnaires.propTypes = {
  dispatch: PropTypes.func,
};

const mapStateToProps = () => ({
});

export default connect(mapStateToProps)(withRouter(PatientKioskQuestionnairesPage));